import { pxToRem, theme } from '@pocketlaw/tetris';
import styled, { css, keyframes } from 'styled-components';
export const Container = styled.div `
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
const backgroundAnimation = keyframes `
  0% {
    opacity: 0.75;
  }
  50% {
    opacity: 0.25;
  }
  100% {
    opacity: 0.75;
  }
`;
export const Header = styled.div `
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: ${theme.spacing['2xl']};
  height: ${pxToRem(172)};
  background-color: ${theme.swatches.gray[100]}; /* Fallback while background-image is loading */
  background-image: ${(props) => !props.$loading && `url(${props.$background})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  ${(props) => props.$loading &&
    css `
      animation: ${backgroundAnimation} 2s ease-in infinite;
    `};
`;
export const Content = styled.div `
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
export const TitleContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${theme.spacing.lg};
  padding: ${theme.spacing['2xl']} ${theme.spacing['7xl']};
`;
